import { Injectable } from '@angular/core';
import { IRacunZaSefObavestenjeDto } from '@kodit/core/data-api';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SefObavestenjeService {
  private _preSelectedRacun$ = new BehaviorSubject<IRacunZaSefObavestenjeDto | null>(null);
  readonly preSelectedRacun$ = this._preSelectedRacun$.asObservable();

  setPreSelectedRacun(racun: IRacunZaSefObavestenjeDto | null): void {
    this._preSelectedRacun$.next(racun);
  }
}
